import { render, staticRenderFns } from "./FlagAvailableContentLanguage.vue?vue&type=template&id=423cd314&scoped=true&"
import script from "./FlagAvailableContentLanguage.vue?vue&type=script&lang=js&"
export * from "./FlagAvailableContentLanguage.vue?vue&type=script&lang=js&"
import style0 from "./FlagAvailableContentLanguage.vue?vue&type=style&index=0&id=423cd314&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423cd314",
  null
  
)

export default component.exports